export default __webpack_public_path__ + "static/media/MobileLaunchPageBackground.ea0ef927.png";